// create for root service with ngxtension
import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID, signal } from '@angular/core';
import { createInjectionToken } from 'ngxtension/create-injection-token';
import { debounceTime, distinctUntilChanged, fromEvent, map } from 'rxjs';

export const [injectWindowsDimensions, provideWindowsDimensions] = createInjectionToken(() => {
    const width = signal<number>(1366);
    const height = signal<number>(768);
    // Only if platform is browser

    if (isPlatformBrowser(inject(PLATFORM_ID))) {
        fromEvent(window, 'resize')
            .pipe(
                debounceTime(400),
                map(() => ({ width: window.innerWidth, height: window.innerHeight })),
                distinctUntilChanged((prev, curr) => prev.width === curr.width && prev.height === curr.height)
            )
            .subscribe(({ width: w, height: h }) => {
                width.set(w);
                height.set(h);
            });
        width.set(window.innerWidth);
        height.set(window.innerHeight);
    }

    return {
        width,
        height,
    };
});
